export default __webpack_public_path__ + "static/media/smooth_logo.ebb6134e.svg";